var _jsxFileName = "/var/home/clovis/Documents/Mangane/app/soapbox/components/ui/icon/svg-icon.tsx";
const _excluded = ["src", "alt", "size", "className"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from 'react';
import InlineSVG from 'react-inlinesvg'; // eslint-disable-line no-restricted-imports

/** Renders an inline SVG with an empty frame loading state */
const SvgIcon = _ref => {
  let {
      src,
      alt,
      size = 24,
      className
    } = _ref,
    filteredProps = _objectWithoutProperties(_ref, _excluded);
  const loader = /*#__PURE__*/React.createElement("svg", {
    className: className,
    width: size,
    height: size,
    "data-src": src,
    "data-testid": "svg-icon-loader",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 18,
      columnNumber: 5
    }
  });
  return /*#__PURE__*/React.createElement(InlineSVG, _extends({
    className: className,
    src: src,
    title: alt,
    width: size,
    height: size,
    loader: loader,
    "data-testid": "svg-icon"
  }, filteredProps, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 28,
      columnNumber: 5
    }
  }), loader);
};
export default SvgIcon;